module.exports = __webpack_public_path__ + "img/iphone.823ffd1f.png";